<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		// 全局变量
		globalData: {
      // 波场钱包环境
			gTronWeb: '',
			// 主合约对象
			gMasterContract: '',
      // 门票合约对象
      gTicketsContract: '',
			// usdt合约对象
			gUSDTContract: '',
		},

		created() {
			window.addEventListener('message', function (e) {
			        if (e.data.message && e.data.message.action === 'setAccount') {
						// 从新链接钱包
						console.log('===监听到了切换钱包, 刷新网页===', e);
            window.location.reload();
			        }
			    })
		},

		methods: {
			// 判断有木有波场钱包环境
			async ifTron() {
				// 获取钱包对象
				let res = await this.$tron.isTronLink();
				// 给出无法点击弹框, 逼着用户必须退出去准备波场环境, 否者无法继续使用
				if(!res.status) {
					console.log('没有发现钱包');
					return;
				}
				// 赋值全局钱包变量
				this.globalData.gTronWeb = window.tronWeb;
				// 创建usdt合约,门票合约,主合约对象
				let masterAddr = this.$contract.masterAddress;
				let masterAbi = this.$contract.masterAbi;
				let uAddr = this.$contract.uAddress;
				let uAbi = this.$contract.uAbi;
        let ticketsAddr = this.$contract.ticketsAddress;
        let ticketsAbi = this.$contract.ticketsAbi;
				this.globalData.gMasterContract = await this.globalData.gTronWeb.contract(masterAbi,masterAddr);
        this.globalData.gTicketsContract = await this.globalData.gTronWeb.contract(ticketsAbi,ticketsAddr);
				this.globalData.gUSDTContract = await this.globalData.gTronWeb.contract(uAbi, uAddr);
				// 同步锁, 执行完后才会执行其他页面的$onLaunched函数; 执行到这说明波场钱包对象和波场合约对象都已经获取到了;
				await this.$isResolve();
			},


		}

	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue